/** @jsx jsx */

import { Icon } from '@zapier/zinnia-icons';
import {
  BetaMenuTriggerRoot,
  BetaMenuTriggerPopover,
  BetaMenuTriggerList,
  BetaMenuTriggerItem,
  Button,
} from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  button: css`
    align-items: center;
    display: flex;
    gap: 4px;
  `,
};

type Props = {
  choices: Array<{ label: string; value: string }>;
  isDisabled: boolean;
  onChoose: (option: { value: string }) => void;
  text: string;
};

const AddInputButton = (props: Props) => {
  const { isDisabled, choices, text, onChoose } = props;

  return (
    <BetaMenuTriggerRoot>
      <Button
        aria-label="Choose the type of input field to add to your Action."
        isDisabled={isDisabled}
      >
        <span css={Styles.button}>
          {text}
          <Icon name="arrowSmallDown" size={30} />
        </span>
      </Button>
      <BetaMenuTriggerPopover>
        <BetaMenuTriggerList
          aria-label="List of input types"
          onAction={key => {
            const choice = choices.find(c => c.value === key);
            if (choice) onChoose(choice);
          }}
        >
          {choices.map(choice => (
            <BetaMenuTriggerItem id={choice.value} key={choice.value}>
              {choice.label}
            </BetaMenuTriggerItem>
          ))}
        </BetaMenuTriggerList>
      </BetaMenuTriggerPopover>
    </BetaMenuTriggerRoot>
  );
};

AddInputButton.defaultProps = {
  text: 'Add',
};

export default AddInputButton;
